import templateUrl from './command-counsellor-group.html';
import moment from "moment";

export const commandCounsellorGroupComponent = {
  templateUrl,
  bindings: {
    details: '<'
  },
  controller: class CommandCounsellorGroupComponent {
    constructor($state, toastr, NewsCategoryService, ModalService, CommandCounsellorsService,AuthService) {
      "ngInject";
      this.$state = $state;
      this.toastr = toastr;
      this.modalService = ModalService;
      this.NewsCategoryService = NewsCategoryService;
      this.CommandCounsellorsService = CommandCounsellorsService;
      this.authService = AuthService;
    }

    $onInit() {
      this.details.createdAt = this.details.createdAt ? moment(this.details.createdAt).format("MM-DD-YYYY") : "";
      this.cmdDetails = this.modifyCommandCounsellorsList(this.details);
    }

    modifyCommandCounsellorsList(allTmGroups) {
      return {
        data: allTmGroups.transitionManagers,
        feature: "Command Career Counselor Groups",
        config: {

          columnDefs: [
            {
              field: "name",
              enableSort: false,
              displayName: "TRANSITION MANAGER NAME",
              rowClass: "underline-field",
              className: "col-lg-3 col-md-3 col-sm-3 text-break",
            },
            {
              field: "unit_identification_code",
              enableSort: false,
              displayName: "UNIT IDENTIFICATION CODE",
              className: "col-lg-3 col-md-3 col-sm-3 text-break",
            },
            {
              type:"date",
              field: "created_at",
              enableSort: true,
              format: "MM/dd/yyyy",
              displayName: "REGISTERED ON",
              rowClass: "text-capitalize",
              className: "col-lg-3 col-md-3 col-sm-3 text-break",
            },
            {
              field: "members",
              enableSort: true,
              displayName: "TOTAL MEMBERS",
              rowClass: "underline-field",
              className: "col-lg-2 col-md-2 col-sm-2 news-link text-break",
            },
          ],
        },
      };
    }
    onEdit(event) {
      // console.log('details event',this.details)
      this.$state.go("commandCounsellorGroupsEdit", { group_id: this.details.groupId })
      this.details.isDetails = true
    }
    onDelete(data) {
      const bodyMsg = "Are you sure to delete this Transistion Manager?";
      this.modalService.open({
        details: {
          bodyMessage: bodyMsg,
        },
        buttons: [
          {
            name: "No",
            action() { },
          },
          {
            name: "Yes",
            isPrimary: true,
            action: _onDelete.bind(this, data),
          },
        ],
      });
      function _onDelete(data) {
        this.CommandCounsellorGroupsService.deleteTMFromGroup(data.career_counselor_profile_id)
          .then((_) => {

            this.toastr.success("Transistion Manager deleted successfully!!");
            this.$state.reload();
          })
          .catch((err) => {
            this.toastr.error(err);
          });
      }
    }
    toMemberlist() {
      this.$state.go("commandCounsellorGroupsMembersList");
    }
    onAdd(event) {
      this.groupId = event.groupId;
      this.$state.go("commandCounsellorAdd",
        {
          unitIdentificationCode: event.unitIdentificationCode,
          groupId: event.groupId
        })
    }
    
    onColumnClick(event, fieldName) {
      if (fieldName === "name") {
        this.$state.go("profileDetail", {
          id: event.account_id,
        });
      } else if (fieldName === "members") {
        this.$state.go("user", {
          source: event.uuid
        });
      } else {
        //
      }
    }

  }
};


// WEBPACK FOOTER //
// ./src/app/components/command-counsellor-group/command-counsellor-group-details/command-counsellor-group.component.js